import { Component, Inject, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ui-fh-loading',
  templateUrl: './fh-loading.component.html',
  styleUrls: ['./fh-loading.component.scss'],
  animations: [
    trigger('labelFade', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class FhLoadingComponent {
  @Input() fullscreen: boolean = false;
  @Input() fullscreenShadow: boolean = false;
  @Input() centered: boolean = true;
  @Input() showFavicon: boolean = false;
  @Input() label: string = '';
  @Input() isListLoading: boolean = false;
  @Input() isDataLoaded = false;

  icon = this.appConfig.icon;
  loadingMessage: string = '';

  constructor(@Inject(APP_CONFIG) protected appConfig: EnvironmentModel, private translate: TranslateService) {
    this.translate.get('shared.loading.title').subscribe((message: string) => {
      this.loadingMessage = message;
    });
  }
}
